<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
            color="secondary"
            outlined
            class="mr-1"
            :to="'/partner/reports/customer/' + customerId + '/user'"
          >
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to User
            Reports
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template v-slot:item.test_score="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    {{ item.test_score }}%
                  </span>
                  <span v-else>T.B.C</span>
                </span>
              </template>
              <template v-slot:item.progress="{ item }">
                {{ item.progress }}%
              </template>
              <template v-slot:item.has_test="{ item }">
                <span v-if="!item.has_test">N/A</span>
                <span v-else>
                  <span v-if="item.test_complete">
                    <span v-if="item.test_passed">
                      <v-icon color="green">fa-check</v-icon>
                    </span>
                    <span v-else>
                      <v-icon color="red">fa-times</v-icon>
                    </span>
                  </span>
                  <span v-else> T.B.C </span>
                </span>
              </template>

              <!-- 5: Take Test / View Course -->
              <template v-slot:item.id="{ item }">
                 <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click.prevent="
                        showUserCourseHistoryPanel(item.id)
                      "
                      v-if=" item.history_exists"
                    >
                      <v-icon small>fas fa-history</v-icon>
                    </v-btn>
                  </template>
                  <span>View Completed Course History</span>
                </v-tooltip>
                  <!-- 3: Download Cert / View Course -->
                  <v-tooltip bottom  v-if="item.certificate_url != null">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        if="item.state == 2"
                        v-on="on"
                        color="secondary"
                        class=""
                        text
                        small
                        @click="generatePDF(item.certificate_url)"
                      >
                        <v-icon small>fa-certificate</v-icon>
                      </v-btn>
                    </template>
                    <span>Download Certificate</span>
                  </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import userAPI from '@/api/user.js';
import courseAPI from '@/api/course.js';
import { EventBus } from '@/event-bus.js';
import ShowUserCourseHistory from '@/components/admin/course/ShowUserCourseHistory';
export default {
  name: 'UserCourseReportDetails',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        { text: 'Course Title', value: 'title', sortable: false },
        { text: 'Status', value: 'state_text', sortable: false },
        {
          text: 'Date Enrolled',
          value: 'enrolled_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Started',
          value: 'start_date_formatted',
          sortable: false,
        },
        {
          text: 'Date Completed',
          value: 'complete_date_formatted',
          sortable: false,
        },
        { text: 'Progress %', value: 'progress', sortable: false },
        { text: 'Deadline', value: 'deadline_formatted', sortable: false },
        { text: 'Test Score', value: 'test_score', sortable: false },
        { text: 'Passed Test', value: 'has_test', sortable: false },

        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      id: this.$route.params.id,
      customerId: this.$route.params.customer_id,
      courses: [],
      loading: false,
      pagination: {},
      options: {},
      radialBarChart: {
        series: this.series,
        chartOptions: {
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '18px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Courses',
                  formatter: function () {
                    return this.total;
                  },
                },
              },
            },
          },
          labels: ['Not Started', 'In progress', 'Completed'],
        },
      },
      successMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
      confirmArchive: 'Are you sure you wish to archive course for this user?',  
      successArchiveMessage: 'Course Archived Successfully.',
    };
  },
  props: {
    total_courses: {
      type: Number,
      default: 0,
    },
    total_in_progress_courses: {
      type: Number,
      default: 0,
    },
    total_completed_courses: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    notStartedCourses: function () {
      return (
        this.total_courses -
        this.total_in_progress_courses -
        this.total_completed_courses
      );
    },
    notStartedPercentage: function () {
      return this.getWholePercent(this.notStartedCourses, this.total_courses);
    },
    inProgessPercentage: function () {
      return this.getWholePercent(
        this.total_in_progress_courses,
        this.total_courses
      );
    },
    completedPercentage: function () {
      return this.getWholePercent(
        this.total_completed_courses,
        this.total_courses
      );
    },
    total: function () {
      return this.total_courses;
    },
    series: function () {
      return [
        this.notStartedPercentage,
        this.inProgessPercentage,
        this.completedPercentage,
      ];
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getWholePercent(percentFor, percentOf) {
      //let precision = Math.pow(10, 1);
      let num = (percentFor / percentOf) * 100;
      return Math.round(num);
    },
    showTest(id) {
      courseAPI
        .getCourse(id, '?include=enrolled,videos,documents,test')
        .then((response) => {
          this.$store.dispatch('setCoursePlayer', response.data.data);
          this.$showPanel({
            component: Test,
            props: {
              course: response.data.data,
            },
            openOn: 'right',
          });
        });
    },
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourses();
      });
    },
    generatePDF(url) {
      if (url != null) {
        window.open(url, '_blank');
      }
    },
    getCourses() {
      this.loading = true;
      userAPI.getArchivedUserCourses(this.id, this.params).then((resp) => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    exportCsv(type) {
      this.loading = true;
      courseAPI
        .exportUserCourseReportCSV(
          this.id,
          '?page=1&orderBy=&sortedBy=asc&limit=' + this.pagination.total,
          '&type=' + type
        )
        .then((resp) => {
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    archiveUserCourse(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUserCourse(toast, id),
          },
        ],
      });
    },
    processArchiveUserCourse(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      courseAPI.archiveUserCourse(id).then(() => {
        this.getCourses();
        this.$snotify.success(this.successArchiveMessage);
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    showUserCourseHistoryPanel(id) {
      this.$showPanel({
        component: ShowUserCourseHistory,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
  },
};
</script>

<style scoped>
.completed {
  color: #ffaf19;
}
.inprogress {
  color: #00e396;
}
.notstarted {
  color: #008efb;
}

.user-report-button-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1em;
}
.reportBackBtn::before{
  opacity: 0.18;
}
.v-btn:not(.v-btn--round).v-size--small{
  min-width: 25px !important;
  padding: 0 4.5px !important;
}
@media (max-width: 960px) {
  .user-report-button-wrapper {
    justify-content: start;
  }
}
</style>
